import { CopyIcon } from '../../../assets/svgIcons/svgIcons';
import CommonTable from '../../../components/common/CustomTable/CommonTable';

const TransactionHistoryTable = () => {
  const fields = [
    'Data & Time',
    'Order ID',
    'BTC Amount',
    'SBTC Amount',
    'Status',
    'Deposit Hash',
    'Minting Hash',
  ];
  const list = [
    {
      date: '10/12/2024 16:46:47',
      order: '0x47685...4c8B',
      btc_amount: '0.001',
      sbtc_amount: '0.00002',
      status: 'Completed',
      deposite: '0x47685...4c8B145',
      minting: 'ox7co...850b3',
    },
    {
      date: '10/12/2024 16:46:47',
      order: '0x47685...4c8B',
      btc_amount: '0.001',
      sbtc_amount: '0.00002',
      status: 'Completed',
      deposite: '0x47685...4c8B145',
      minting: 'ox7co...850b3',
    },
    {
      date: '10/12/2024 16:46:47',
      order: '0x47685...4c8B',
      btc_amount: '0.001',
      sbtc_amount: '0.00002',
      status: 'Completed',
      deposite: '0x47685...4c8B145',
      minting: 'ox7co...850b3',
    },
    {
      date: '10/12/2024 16:46:47',
      order: '0x47685...4c8B',
      btc_amount: '0.001',
      sbtc_amount: '0.00002',
      status: 'Completed',
      deposite: '0x47685...4c8B145',
      minting: 'ox7co...850b3',
    },
    {
      date: '10/12/2024 16:46:47',
      order: '0x47685...4c8B',
      btc_amount: '0.001',
      sbtc_amount: '0.00002',
      status: 'Completed',
      deposite: '0x47685...4c8B145',
      minting: 'ox7co...850b3',
    },
  ];
  return (
    <div className="activity_table">
      <CommonTable fields={fields} tableTitle="Transaction history">
        {list?.map((item: any, index: number) => (
          <tr key={index}>
            <td>{item?.date}</td>
            <td>
              <div>
                {item?.order}
                <button className="copyicon">
                  <CopyIcon />
                </button>
              </div>
            </td>
            <td>{item?.btc_amount}</td>
            <td>{item?.sbtc_amount}</td>
            <td>{item?.status}</td>
            <td>
              <div>
                {item?.deposite}
                <button className="copyicon">
                  <CopyIcon />
                </button>
              </div>
            </td>
            <td>
              <div>
                {item?.minting}{' '}
                <button className="copyicon">
                  <CopyIcon />
                </button>
              </div>
            </td>
          </tr>
        ))}
      </CommonTable>
    </div>
  );
};

export default TransactionHistoryTable;
